import { service } from "@/utils/request";
export default {
  addOrUpdateTitle(data) {
    return service({
      url: "/cloud/bbs/v1/admin/marketing/addOrUpdate",
      method: "post",
      data
    });
  },
  /**
   * userType 1-孕妈app，2-医生app
   * type 类型：1-主编力荐，2-推荐好物，3-限时促销，4-直播提醒，5-图片，11-vip会员权益，12-vip优选好物，13-vip专享资源，14-vip礼品，15-vip云顾问，16-vip线下培训
   * @param {*} params
   * @returns
   */
  getTitleInfo(params) {
    return service({
      url: "/cloud/bbs/v1/admin/marketing/getConfig",
      method: "get",
      params
    });
  },
  setHomeLiveCount(params) {
    return service({
      url: "/cloud/bbs/v1/admin/marketing/setHomeLiveCount",
      method: "post",
      params
    });
  },
  getHomeLiveCount() {
    return service({
      url: "/cloud/bbs/v1/admin/marketing/getHomeLiveCount",
      method: "get"
    });
  }
};


// WEBPACK FOOTER //
// ./src/api/operateManage/titleManage.js